"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_orchestration_1 = require("owa-options-orchestration");
var OptionsFull_1 = require("../components/full/OptionsFull");
var owa_options_store_1 = require("owa-options-store");
function mountAndShowFullOptions(category, subcategory, option) {
    var wasPreviouslyShown = owa_options_store_1.getStore().isFullOptionsShown;
    owa_options_orchestration_1.showFullOptions(category, subcategory, option);
    if (!wasPreviouslyShown) {
        OptionsFull_1.mountOptionsFullPopup();
    }
}
exports.default = mountAndShowFullOptions;
//# sourceMappingURL=mountAndShowFullOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/view/owa-options-view/lib/utils/mountAndShowFullOptions.js
// module id = 3366
// module chunks = 2